import { Injectable } from '@angular/core';
import { of, Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { timeout, catchError} from "rxjs/operators";
import { environment } from "../../../../../environments/environment";
import { SearchCriteria } from './model/searchCriteria';
import { WhoOwnsIt } from './model/whoOwnsIt';

@Injectable()
export class DataAccessService {

  private baseUrl = environment.apiURL;
  
  constructor(private http: HttpClient) {
  }

  getTenantActivities(rowsOnPage?: any): Observable<any> {
    let headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'Accept': 'application/json',
      'Authorization':'Bearer '+localStorage.getItem("access_token"),
      'scac': JSON.parse(localStorage.getItem("user-tenant")).scac,
      'request-source': 'WEB',
      'fetch-all':'true',
    });

    const a: string = this.baseUrl  +
      'get-user-data-access/v1?size='+rowsOnPage+'&page=0&sort-by=billOfLadingId&order-by=asc';
    return this.http.get(a, {headers: headers}).pipe(timeout(40000),
    catchError(error => of(`Timeout`)));
  }

  getAccessControls(rowsOnPage?: any, page?: any, searchCriteria?: SearchCriteria): Observable<any> {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization':'Bearer '+localStorage.getItem("access_token"),
      'scac': JSON.parse(localStorage.getItem("user-tenant")).scac,
      'request-source': 'WEB',
      'fetch-all':'true',
    });

    const a: string = this.baseUrl  +
      'get-user-data-access/v2?size='+rowsOnPage+'&page='+page+'&sort-by=billOfLadingId&order-by=asc';
    return this.http.post(a, searchCriteria, {headers: headers}).pipe(timeout(40000),
    catchError(error => of(`Timeout`)));
  }

  deleteAccessControls(whoOwnsIt: WhoOwnsIt): Observable<any> {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization':'Bearer '+localStorage.getItem("access_token"),
      'scac': JSON.parse(localStorage.getItem("user-tenant")).scac,
      'request-source': 'WEB',
      'fetch-all':'true',
    });

    const a: string = this.baseUrl  +
      'delete-user-data-access';
    return this.http.post(a, whoOwnsIt, {headers: headers}).pipe(timeout(40000),
    catchError(error => of(`Timeout`)));
  }

  getFilterControls(rowsOnPage?: any, page?: any): Observable<any> {
    let headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'Accept': 'application/json',
      'Authorization':'Bearer '+localStorage.getItem("access_token"),
      'scac': JSON.parse(localStorage.getItem("user-tenant")).scac,
      'request-source': 'WEB',
      'fetch-all':'true',
    });

    const a: string = this.baseUrl  +
      'get-user-data-access-filters?size='+rowsOnPage+'&page='+page+'&sort-by=billOfLadingId&order-by=asc';
    return this.http.get(a, {headers: headers}).pipe(timeout(40000),
    catchError(error => of(`Timeout`)));
  }

  getDealers(tenant): Observable<any> {
    let headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'Accept': 'application/json',
      'Authorization':'Bearer '+localStorage.getItem("access_token"),
      'scac': localStorage.getItem("user_scac"),
      'request-source': 'WEB',
      'tenant': tenant,
    });

    const a: string = this.baseUrl  +
      'get-dealers-related-to-tenant?size=1000000&page=0&sort-by=billOfLadingId&order-by=asc';
    return this.http.get(a, {headers: headers}).pipe(timeout(40000),
    catchError(error => of(`Timeout`)));
  }

  saveTenant(tenant): Observable<any> {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization': 'Bearer ' + localStorage.getItem("access_token"),
      'scac' : JSON.parse(localStorage.getItem("user-tenant")) ? JSON.parse(localStorage.getItem("user-tenant")).scac : "prod",
      'username': sessionStorage.getItem("user_name"),
      'password': sessionStorage.getItem("user_password"),
    });

    tenant.updatedDate = tenant.updatedDate ? tenant.updatedDate.replace("T", " ").replace(".000Z", "") : tenant.updatedDate;

    const a: string = this.baseUrl + 'save-complete-tenant-details';
      return this.http.post(a, JSON.stringify(tenant), {headers: headers}).pipe(timeout(40000),
                catchError(error => of(`Timeout`)));
  }

  saveWhoOwnsIt(whoOwnsIt): Observable<any> {
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    const a: string = this.baseUrl + 'public/' +
      'save-user-data-access';
      return this.http.post(a, JSON.stringify(whoOwnsIt), {headers: headers})
                .pipe(timeout(40000),
                catchError(error => of(`Timeout`)))
  }

  /**
   * Used for deleting WhoOwnsIt record.
   * 
   * @param whoOwnsIt 
   */
  public deleteWhoOwnsIt(whoOwnsIt): Observable<any> {
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    const a: string = this.baseUrl + 'public/' +
      'delete-user-data-access';
      return this.http.post(a, JSON.stringify(whoOwnsIt), {headers: headers})
                .pipe(timeout(40000),
                catchError(error => of(`Timeout`)));
  }

  private extractData(res: Response) {
    return res.json() || {};
  }

  private handleError(error: Response | any) {
    let errMsg: string;
    if (error instanceof Response) {
      const body = error.json() || '';
      const err = JSON.stringify(body);
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    console.error(errMsg);
    return Observable.throw(errMsg);
  }
}
